<template>
    <fade-up-animation :element="() => $refs.section">
        <lazy-background
            class="basic-background-hero-section"
            :src="backgroundImage.src"
            :alt="backgroundImage.alt"
            tag="section"
            ref="section"
        >
            <b-container>
                <mobile-gutter>
                    <h1 v-test:title class="title">{{ title }}</h1>
                </mobile-gutter>
            </b-container>
        </lazy-background>
    </fade-up-animation>
</template>

<script>
    export default {
        name: 'basic-background-hero-section',

        props: {
            title: {
                type: String,
                required: true,
            },

            backgroundImage: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .basic-background-hero-section {
        color: #ffffff;
        text-align: center;
        padding: 50px 0;
        position: relative;

        @include media-breakpoint-up(md) {
            padding: 85px 0;
        }

        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba($black, 0.2);
        }
    }

    .title {
        margin: 0;
        position: relative;
        z-index: 1;
    }
</style>
